import css from './UserExtra.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import DataTestId from 'meta/dataTestId'
import { CookieClient, CookieName } from 'utils/cookie'

import { ButtonRed } from 'components/Actions/Action'
import { ButtonBlackWhite } from 'components/Actions/Action/Button'
import { useV4TicketStatus } from 'components/Pages/Wallet/hooks/useTicketStatus'
import { useFunUrl } from 'hooks/useEnv'

import { UserExtraProps } from './UserExtraContainer'

const UserExtra: React.FC<UserExtraProps> = (props) => {
  const { baseProps, ticketData, typeTicketData } = props
  const { eventData, walletEventData } = baseProps

  const { t } = useTranslation()
  const funUrl = useFunUrl()

  const status = useV4TicketStatus({ userTicketData: ticketData, walletEventData })

  const onPrint = async () => {
    const authToken = CookieClient.get(CookieName.TOKEN)
    const printUrl = `${funUrl}/pdf/index.php?e=${eventData.id}&s=${ticketData.secret}&token=${authToken}`
    window.open(printUrl, '_blank')
  }

  return (
    <div data-testid={DataTestId.wallet.userExtraDesktop} className={css.userExtra}>
      <div className={css.left}>
        <div>
          <div className={css.desc}>{t('wallet:extraType')}:</div>
          <div className={css.data}>{typeTicketData.notes}</div>
        </div>
        <div>
          <div className={css.desc}>{t('wallet:statusLabel')}:</div>
          <div data-testid={DataTestId.wallet.ticketStatus} className={css.data}>
            {status}
          </div>
        </div>
      </div>
      <div className={css.right}>
        <ButtonRed className={css.printBtn} onClick={onPrint}>
          <div>{t('wallet:seePDF')}</div>
        </ButtonRed>
        {ticketData.fiscalData.receiptUri && (
          <ButtonBlackWhite
            className={css.receiptBtn}
            onClick={() => {
              if (ticketData.fiscalData.receiptUri) {
                window.open(ticketData.fiscalData.receiptUri, '_blank')
              }
            }}
          >
            <h5>{t('wallet:show_receipt')}</h5>
          </ButtonBlackWhite>
        )}
      </div>
    </div>
  )
}

export default UserExtra
